import { render } from "./ModalAuthorization.vue?vue&type=template&id=d9c7ace6&scoped=true"
import script from "./ModalAuthorization.vue?vue&type=script&lang=js"
export * from "./ModalAuthorization.vue?vue&type=script&lang=js"

import "./ModalAuthorization.vue?vue&type=style&index=0&id=d9c7ace6&lang=scss"
import "./ModalAuthorization.vue?vue&type=style&index=1&id=d9c7ace6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9c7ace6"],['__file',"webpack-assets/vue/templates/site/authorization/ModalAuthorization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9c7ace6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9c7ace6', __exports__)) {
    api.reload('d9c7ace6', __exports__)
  }
  
  module.hot.accept("./ModalAuthorization.vue?vue&type=template&id=d9c7ace6&scoped=true", () => {
    api.rerender('d9c7ace6', render)
  })

}


export default __exports__